import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var onboarding = new GatewayService('onboarding-service');
var apiRoot = 'ims/oneroster/v1p1';

var fetchClass = function fetchClass(classSourcedId) {
  return onboarding.get("".concat(apiRoot, "/classes/").concat(classSourcedId));
};

var fetchClassRoster = function fetchClassRoster(classSourcedId) {
  return onboarding.get("".concat(apiRoot, "/classes/").concat(classSourcedId, "/students"));
};

var fetchUserClasses = function fetchUserClasses(userKey) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = {
    limit: 100,
    offset: 0,
    orderBy: 'asc'
  };

  if (filter) {
    params.filter = filter;
  }

  return onboarding.get("".concat(apiRoot, "/users/").concat(userKey, "/classes"), {
    params: params
  }).then(function (response) {
    var classes = _.get(response, 'classes', []);

    return {
      classes: setUniqueDisplayNames(classes, true)
    };
  });
};

var fetchUser = function fetchUser(userKey) {
  return onboarding.get("".concat(apiRoot, "/users/").concat(userKey));
};

var renameDuplicateNames = function renameDuplicateNames() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var nameMapping = {};
  classes.forEach(function (classObj, idx) {
    nameMapping[classObj.displayName] = nameMapping[classObj.displayName] ? nameMapping[classObj.displayName].concat([idx]) : [idx];
  });
  return classes.map(function (classObj, idx) {
    var nameIndexes = nameMapping[classObj.displayName];
    var displayName = nameIndexes.length === 1 ? classObj.displayName : "".concat(classObj.displayName, " (").concat(nameIndexes.indexOf(idx) + 1, ")");
    return Object.assign({}, classObj, {
      displayName: displayName
    });
  });
};

var sortClassesByDisplayName = function sortClassesByDisplayName() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return classes.sort(function (a, b) {
    var displayNameA = a.displayName.toLowerCase();
    var displayNameB = b.displayName.toLowerCase();
    return displayNameA > displayNameB ? 1 : displayNameB > displayNameA ? -1 : 0;
  });
};

var addDisplayNamePropToClasses = function addDisplayNamePropToClasses(classes) {
  return classes.map(function (classObj) {
    var metadataDisplayName = _.get(classObj, 'metadata.displayName', '').trim();

    var displayName = _.isEmpty(metadataDisplayName) ? classObj.title : metadataDisplayName;
    return Object.assign({}, classObj, {
      displayName: displayName
    });
  });
};

var setUniqueDisplayNames = function setUniqueDisplayNames() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var updatedClasses = renameDuplicateNames(addDisplayNamePropToClasses(classes));
  return sortNames ? sortClassesByDisplayName(updatedClasses) : updatedClasses;
};

export default {
  fetchClass: fetchClass,
  fetchClassRoster: fetchClassRoster,
  fetchUserClasses: fetchUserClasses,
  fetchUser: fetchUser,
  setUniqueDisplayNames: setUniqueDisplayNames
};